import React, { useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router";
import { Spin } from "antd";
import { RequestEditor } from "@companion-core/shared/app/Components/Requests/RequestDetail/RequestEditor";
import { RequestDetailAction } from "@companion-core/shared/app/Components/Requests/RequestDetail/requestDetail.model";
import { useRequest } from "@companion-core/shared/app/Queries/requests";
import { APIRequest } from "@companion-core/shared/app/Interfaces/API";

const Editor = () => {
  const navigate = useNavigate();
  const { id, action } = useParams();
  const { data, isError } = useRequest(id ?? "", !!id);
  const request = useMemo(() => data?.data?.result as APIRequest, [data]);

  useEffect(() => {
    if (action && !(action in RequestDetailAction)) {
      navigate(`/my-requests/${id}/details`);
    }
  }, []);

  useEffect(() => {
    if (isError) {
      navigate("/my-requests");
    }
  }, [isError]);

  return request && id ? (
    <RequestEditor requestData={request} id={id} action={action as RequestDetailAction} />
  ) : (
    <div className="my-requests__no-request">
      <Spin data-testid="my-requests__loader" size="large" />
    </div>
  );
};

export default Editor;
